import { isMobile } from './device'

export function sleep(ms = 300) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function getLettersName(name: string) {
  if (!name) return '';
  
  const splittedName = name.split(' ')

  if (splittedName.length === 1) {
    const [name] = splittedName

    return (name.charAt(0) + name.charAt(name.length - 1)).toUpperCase()
  } else {
    const firstLetterName = splittedName[0].charAt(0)

    const firstLetterLastName = splittedName.pop()?.charAt(0)

    return (firstLetterName + firstLetterLastName).toUpperCase()
  }
}

export function goToScrollTop() {
  const target = isMobile()
    ? (document.getElementById('app-wrapper') as HTMLDivElement)
    : document.documentElement

  target.scrollTo({
    behavior: 'smooth',
    top: 0,
  })
}
